import React, {useEffect} from 'react';
import track from 'utils/track';
import SalesIndex from './join';

export default function () {
  useEffect(() => {
    track('Product Viewed', {
      product_id: 'C-HBC',
      sku: 'C-HBC',
      name: 'Healthy Brain',
      variant: 'hbc-special',
      value: 297,
      currency: 'usd'
    });
  }, []);
  return <SalesIndex ctaOverride="sales297" ctaNoTimer />;
}
